import { AfterViewChecked, Component, ElementRef, Input, OnChanges, signal, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'dynamic-view',
  template: ` <div #textContainer class="line-clamp" [innerHTML]="content"></div> `,
  styleUrls: ['dynamic-view.component.less'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class DynamicViewComponent implements AfterViewChecked, OnChanges {
  @Input() content: string;

  protected _hasLineClamp$ = new Subject<boolean>();
  public hasLineClamp$ = this._hasLineClamp$.asObservable();

  private hasLineClamp: boolean = false;
  private calculated: boolean = false;

  @ViewChild("textContainer") protected textRef: ElementRef<HTMLElement>;
  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this.calculated = false;
    }
  }

  ngAfterViewChecked(): void {
    this.calculateLineClamp();
  }

  private calculateLineClamp() {

    let check = false;
    if (!this.textRef) {
      //do nothing
    }
    else {
      if (this.calculated) {
        return;
      }

      const html = this.textRef.nativeElement
      if (html.scrollHeight > html.clientHeight) {
        check = true;
      }
    }
    setTimeout(() => {

      if (this.hasLineClamp !== check) {
        this.calculated = true;
        this.hasLineClamp = check;
        this._hasLineClamp$.next(check);
      }
    }, 0);
  }
}